// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/Users/guanwenchao/Documents/ChatGPT/h5自建站/node_modules/.pnpm/dva-loading@3.0.25_dva-core@1.6.0-beta.7_redux@4.2.1_/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelEditorModal0 from '/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/editor/models/editorModal.js';
import ModelEditorPcModel1 from '/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/editor/models/editorPcModel.ts';
import dvaImmer, { enableES5, enableAllPlugins } from '/Users/guanwenchao/Documents/ChatGPT/h5自建站/node_modules/.pnpm/dva-immer@0.5.2_dva@2.6.0-beta.23_react-dom@16.14.0_react@16.14.0__react-router@5.3.4_react@16.14.0__react@16.14.0_/node_modules/dva-immer/dist/index.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  app.use(dvaImmer());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'editorModal', ...ModelEditorModal0 });
app.model({ namespace: 'editorPcModel', ...ModelEditorPcModel1 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
